import React from "react";
import { Field } from "formik";
import { InputContainer } from "styles/components/AnimatedTextArea";

const Textarea = (props) => (
  <Field name={props?.name}>
    {({ field, meta, form }) => {
      return (
        <InputContainer>
          <div className="input-container">
            <textarea
              className={`${meta.touched && meta.error ? "" : ""}`}
              name={field.name}
              maxLength={props?.maxLength || 400}
              cols={props.cols}
              rows={props?.rows}
              disabled={props.disabled}
              placeholder={props?.displayFloatingLabel === false ? props?.placeholder : undefined}
              onKeyUp={(evt) => {
                form.setFieldValue(props?.name, evt.target.value);
                props?.onChangeHandler && props?.onChangeHandler(evt.target.value, field.value)
              }}
              onBlurCapture={() => {
                props?.blurHandler && props?.blurHandler(field.value)
              }}
              {...field}
              value={props?.value !== undefined && props?.value !== null ? props?.value : (field.value || "")}
            />
            {props?.displayFloatingLabel !== false && (
              <label className={field.value && 'filled'} htmlFor={props?.name}>
                {props?.placeholder}
              </label>
            )}
            {meta.touched && meta.error && props?.showErrorMessages && (
              <p name={props?.name + "Error"} className="error-message">{meta.error}</p>
            )}
          </div>
        </InputContainer>
      );
    }}
  </Field>
);

export default Textarea;
